(ns practitest.frontend.components2.dashboard.helpers
  (:require [practitest.frontend.components2.dashboard.schema :as sc]
            [clojure.string :as s]
            [clojure.math :as math]))

(def ^:private default-colors
  {"planned" "#3967F2"
   "executed" "#D6242A"})

(def other-label "Other")
(def x-value "__X_VALUE__")
(def y-value "__Y_VALUE__")
(def age-min-value "__AGE_MIN__")
(def age-max-value "__AGE_MAX__")

(defn pick-color
  {:malli/schema [:=> [:cat sc/ColorMap :string :int]
                  :string]}
  [colors-palette label idx]
  (let [colorsv (-> colors-palette vals sort)]
    (or (-> label str s/lower-case colors-palette)
        (nth colorsv (mod idx (count colorsv))))))

(defn assign-colors
  {:malli/schema [:=> [:cat sc/ColorMap [:vector :string]]
                  sc/ColorMap]}
  [colors-palette labels]
  (into {}
        (for [[idx label] (map-indexed vector labels)]
          [label (pick-color colors-palette label idx)])))

(defn palette
  "Return color palette for chart, merged from color maps and user colors."
  {:malli/schema [:=> [:cat
                       [:map [:chart/user-colors [:maybe sc/ColorMap]]]
                       [:vector [:map-of :string :string]]]
                  sc/ColorMap]}
  [{:chart/keys [user-colors]} colors-map]
  (let [colors (concat colors-map [default-colors] [user-colors])]
    (into {} (map #(update-keys % s/lower-case) colors))))

(defn parse-colors
  {:malli/schema [:=> [:cat [:maybe :string]]
                  sc/ColorMap]}
  [s]
  (->> (str s)
       (re-seq #"(?i)([\w\s-]+):\s*'?(#[0-9A-F]{6})'?")
       (into {}
             (map (fn [[_ label color]]
                    [(-> label s/trim s/lower-case) (s/trim color)])))))

(defn calc-percent [total-amount amount]
  (if (zero? total-amount)
    0
    (math/round (* 100 (/ amount total-amount)))))

(def str->bool
  (comp pos?
        parse-long
        str))

(defn- url-search-params [parsed]
  (-> parsed .-searchParams .entries js/Array.from js->clj))

(defn parse-url
  {:malli/schema [:=> [:cat [:maybe :string]]
                  [:maybe sc/Route]]}
  [url]
  (when url
    (try
      (let [parsed (js/URL. url)
            uri    (str (.-origin parsed) (.-pathname parsed))]
        (reduce (fn [acc [k v]]
                  (condp = v
                    x-value       (assoc-in acc [:ext :x-param] k)
                    y-value       (assoc-in acc [:ext :y-param] k)
                    age-min-value (assoc-in acc [:ext :age-min-param] k)
                    age-max-value (assoc-in acc [:ext :age-max-param] k)
                    (update acc :params conj [k v])))
                {:ext {} :params [] :uri uri}
                (url-search-params parsed)))
      (catch js/Error ex
        (js/console.error ex)))))

(defn- ->vec [v] (if (sequential? v) v [v]))

(defn url-for
  {:malli/schema [:=> [:cat
                       [:maybe sc/Route]
                       [:map-of :keyword [:or :string [:vector :string]]]]
                  [:maybe :string]]}
  [{:keys [uri params ext]} new-params]
  (when uri
    (let [new-params
          (for [[k v] new-params
                value (->vec v)]
            [(get ext k k) value])]
      (reduce (fn [q [k v]]
                (str q k "=" (js/encodeURIComponent (str v)) "&"))
              (str uri "?")
              (concat params new-params)))))

(defn filters-title
  "Generate view name with optional auto-filter values.

   If auto-filter is present, appends filter values to view name.
   Otherwise returns view name or default 'All {entity-name}' text."
  [{:keys             [custom-view-auto-filter entity-name-plural custom-view]
    {auto-filter :auto-filter
     view-name   :name} :custom-view}]
  (let [auto-filter? (and (seq custom-view-auto-filter)
                          (some? view-name)
                          (seq auto-filter))]
    (cond
      auto-filter?        (let [af-values (s/replace custom-view-auto-filter ";" " / ")]
                            (str view-name " - " af-values))
      (some? custom-view) view-name
      :else               (str "All " entity-name-plural))))

(vector [:ok])

(defn legend-item-active?
  [chart label]
  (get (:chart/toggle-legend chart) label true))

(defn active-series
  [series toggle-legend]
  (filterv #(toggle-legend (:name %) true) series))

(defn x-label-visible-step [categories-count cell-width]
  "Determines how frequently X-axis labels should be displayed
    to avoid overlap when the number of categories grows."
  (if (= cell-width :double)
    (cond
      (> categories-count 80) 4
      (> categories-count 60) 3
      (> categories-count 30) 2
      :else                   nil)
    (cond
      (> categories-count 70) 6
      (> categories-count 60) 5
      (> categories-count 40) 4
      (> categories-count 16) 3
      (> categories-count 9)  2
      :else                   nil)))